/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const genBarcodeService = {
  getGenBarcode: (params: any) => request.get('/gen-barcode', { params })
};

export default genBarcodeService;
